import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import setup from '../assets/data/setup.json';

function Footer() {
  const year = new Date().getFullYear();
  const closing = (setup as { footerClosing?: string }).footerClosing;

  return (
    <footer className="border-t border-line py-12 px-5 sm:px-8">
      <div className="max-w-content mx-auto">
        {closing && (
          <p className="text-base sm:text-lg text-ink-secondary leading-relaxed text-center max-w-2xl mx-auto mb-10">
            {closing}
          </p>
        )}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="text-center sm:text-left">
            <p className="text-sm font-medium text-ink">{setup.profile.name}</p>
            <p className="text-xs text-ink-muted mt-1">© {year} All rights reserved.</p>
          </div>
          <div className="flex items-center gap-2">
            <a
              href={setup.profile.github}
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
              className="ui-btn-secondary !px-3 !py-2"
            >
              <GitHubIcon sx={{ fontSize: 18 }} />
            </a>
            <a
              href={setup.profile.linkedin}
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className="ui-btn-secondary !px-3 !py-2"
            >
              <LinkedInIcon sx={{ fontSize: 18 }} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
